export default __webpack_public_path__ + "static/Logo 1-601e01a71db1745682d5db48cc95ed30.png";